import AgencyPrefixes from "./routes/agency-worker/AgencyPrefixes.tsx";
import InternationalPrefixes from "./routes/agency-worker/InternationalPrefixes.tsx";
import OnixCodetables from "./routes/onix/OnixCodetables.tsx";
import OnixCodetableItems from "./routes/onix/OnixCodetableItems.tsx";
import Collections from "./routes/collections/Collections.tsx";
import PublisherPrefixRanges from "./routes/publisher-prefix-range/PublisherPrefixRanges.tsx";
import PublisherPrefixes from "./routes/publisher-prefix/PublisherPrefixes.tsx";
import NaturalPersons from "./routes/natural-person/NaturalPersons.tsx";
import Titles from "./routes/title/Titles.tsx";
import Products from "./routes/product/Products.tsx";
import LegalPersons from "./routes/legal-person/LegalPersons.tsx";
import { Publishers } from "./routes/publisher/Publishers.tsx";
import ProductNumbers from "./routes/product-number/ProductNumbers.tsx";
import { AdminPage } from "./routes/admin/AdminPage.tsx";
import { SolrAdminPage } from "./routes/admin/SolrAdminPage.tsx";
import { AuthorityUpdateAdminPage } from "./routes/admin/AuthorityUpdateAdminPage.tsx";
import { IssnRegisterAdminPage } from "./routes/admin/IssnRegisterAdminPage.tsx";
import { AlephTitleSyncAdminPage } from "./routes/admin/AlephTitleSyncAdminPage.tsx";
import Outputs from "./routes/outputs/Outputs.tsx";
import Import from "./routes/import/Import.tsx";
import CoEditionRequests from "./routes/co-edition/CoEditionRequests.tsx";
// #RoutesConfigImport
import { RoleEnum } from "./types/RoleEnum.ts";

export const routesConfig = {
  agencyPrefixes: {
    path: "/agency-prefixes",
    component: AgencyPrefixes,
    roles: [RoleEnum.AGENCY_WORKER],
  },
  internationalPrefixes: {
    path: "/international-prefixes",
    component: InternationalPrefixes,
    roles: [RoleEnum.AGENCY_WORKER],
  },
  collections: {
    path: "/collections",
    component: Collections,
    roles: [
      RoleEnum.AGENCY_WORKER,
      RoleEnum.PUBLISHER_GUARANTOR,
      RoleEnum.PUBLISHER_ADMIN,
      RoleEnum.DISTRIBUTOR,
      RoleEnum.COLLECTIONS_ADMINISTRATOR,
    ],
  },
  onixCodetables: {
    path: "/onix-codetables",
    component: OnixCodetables,
    roles: [RoleEnum.ONIX_CODETABLES_ADMINISTRATOR],
  },
  onixCodetableItems: {
    path: "/onix-codetable-items",
    component: OnixCodetableItems,
    roles: [RoleEnum.ONIX_CODETABLES_ADMINISTRATOR],
  },
  publisherPrefixRanges: {
    path: "/publisher-prefix-ranges",
    component: PublisherPrefixRanges,
    roles: [RoleEnum.AGENCY_WORKER],
  },
  naturalPersons: {
    path: "/natural-persons",
    component: NaturalPersons,
    roles: [
      RoleEnum.AGENCY_WORKER,
      RoleEnum.DISTRIBUTOR,
      RoleEnum.PUBLISHER_GUARANTOR,
      RoleEnum.PUBLISHER_ADMIN,
    ],
  },
  legalPersons: {
    path: "/legal-persons",
    component: LegalPersons,
    roles: [
      RoleEnum.AGENCY_WORKER,
      RoleEnum.DISTRIBUTOR,
      RoleEnum.PUBLISHER_GUARANTOR,
      RoleEnum.PUBLISHER_ADMIN,
    ],
  },
  titles: {
    path: "/titles",
    component: Titles,
    roles: [
      RoleEnum.AGENCY_WORKER,
      RoleEnum.PUBLISHER_GUARANTOR,
      RoleEnum.PUBLISHER_ADMIN,
      RoleEnum.DISTRIBUTOR,
    ],
  },
  products: {
    path: "/products",
    component: Products,
    roles: [
      RoleEnum.AGENCY_WORKER,
      RoleEnum.PUBLISHER_GUARANTOR,
      RoleEnum.PUBLISHER_ADMIN,
      RoleEnum.DISTRIBUTOR,
    ],
  },
  publishers: {
    path: "/publishers",
    component: Publishers,
    roles: [
      RoleEnum.AGENCY_WORKER,
      RoleEnum.PUBLISHER_GUARANTOR,
      RoleEnum.PUBLISHER_ADMIN,
      RoleEnum.COLLECTIONS_ADMINISTRATOR,
    ],
  },
  publisherPrefixes: {
    path: "/publisher-prefixes",
    component: PublisherPrefixes,
    roles: [
      RoleEnum.AGENCY_WORKER,
      RoleEnum.PUBLISHER_GUARANTOR,
      RoleEnum.PUBLISHER_ADMIN,
      RoleEnum.COLLECTIONS_ADMINISTRATOR,
    ],
  },
  productNumbers: {
    path: "/product-numbers",
    component: ProductNumbers,
    roles: [
      RoleEnum.AGENCY_WORKER,
      RoleEnum.PUBLISHER_GUARANTOR,
      RoleEnum.PUBLISHER_ADMIN,
      RoleEnum.DISTRIBUTOR,
    ],
  },
  coEditionRequests: {
    path: "/co-edition-requests",
    component: CoEditionRequests,
    roles: [RoleEnum.AGENCY_WORKER],
  },
  adminEnvironmentVariables: {
    path: "/admin/environment-variables",
    component: AdminPage,
    roles: [RoleEnum.SUPERUSER],
  },
  adminSolr: {
    path: "/admin/solr",
    component: SolrAdminPage,
    roles: [RoleEnum.SUPERUSER],
  },
  adminAuthorityUpdate: {
    path: "/admin/authority-update",
    component: AuthorityUpdateAdminPage,
    roles: [RoleEnum.SUPERUSER],
  },
  adminIssnRegister: {
    path: "/admin/issn-register",
    component: IssnRegisterAdminPage,
    roles: [RoleEnum.SUPERUSER],
  },
  adminAlephTitleSync: {
    path: "/admin/aleph-title-sync",
    component: AlephTitleSyncAdminPage,
    roles: [RoleEnum.SUPERUSER],
  },
  outputs: {
    path: "/outputs",
    component: Outputs,
    roles: [
      RoleEnum.AGENCY_WORKER,
      RoleEnum.PUBLISHER_GUARANTOR,
      RoleEnum.PUBLISHER_ADMIN,
    ],
  },
  import: {
    path: "/import",
    component: Import,
    roles: [RoleEnum.SUPERUSER],
  },
  // #RoutesConfiguration
};

export const preferredFallbackRouteKey = "titles";
